import React, { useEffect, useRef } from 'react'
import Select from 'react-select';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, setValue } from "react-hook-form";
import { checkAccess } from '../../../actions/securityactions'
import * as constants from './../constants';
import * as actions from '../actions/secmasteractions';
import NavBar from '../../../components/NavBar';
import TopBar from '../../../components/newdashboardcomponent/TopBar';
import SideNav from '../../../components/SideNav';
import DashboardTitle from '../../../components/DashboardTitle';
import Footer from '../../../components/Footer';
import { CustomFileUpload } from '../../../components/CustomFileUpload';
import CustomPager from '../../../components/custompager';
import ApplicableBrancehes from '../components/ApplicableBranches';
import LeftSideMenu from '../../../components/newdashboardcomponent/LeftSideMenu';
//import PartyCode from '../components/PartyCode';


export default function UserMainScreen() {

    const state = useSelector(state => state.secmasterReducer);
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { register: registerUserSearch,
        reset: resetUserSearch, handleSubmit: onSubmitData, setValue: setUserSearchValue, watch: watchUserSearch, formState: { errors: errorsUserSearch } } = useForm();


    const { register: registerUserMaster, handleSubmit: onSubmitUserMaster,
        reset: resetUserMaster, getFieldState, setValue, watch: watchPolicyInformation, formState: { errors: errorsUserMaster } } = useForm();


    let modalsState = state.modalsState;
    let masters = state.masters;
    let userSearch = state.userSearch;
    let userMaster = state.userMaster;
    let checkPermissions = state.checkPermissions;
    console.log("userSearch", userSearch);
    console.log("userMaster", userMaster);
    console.log("masters", masters);
    console.log("branchMasters", state.applicableBranches.branchMasters);
    var productType = null;
    const refUserMaster = useRef(null);
    const refPartyCode = useRef(null);
    //UPDATE_USER_SEARCH_PARAMS in actiontype
    useEffect(() => {
        async function CheckPermissions() {
            await dispatch(checkAccess({ pageMenuId: 702 }));
            await dispatch(actions.checkSecurityModuleAccess());
            await dispatch(actions.getInsuredInfoMasters(0));
            await dispatch(actions.getSecurityMasters());
        }
        CheckPermissions();
    }, []);

    useEffect(() => {
        let valuesToMap = [
            { "userId": userSearch.userId },
            { "userName": userSearch.userName },
            { "activeFrom": userSearch.activeFrom },
            { "activeTo": userSearch.activeTo }

        ];
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setUserSearchValue(key, i[key])));
    }, [userSearch]);

    useEffect(() => {
        // if (quoteInformation.quotationId) {
        let valuesToMap = [
            { "userId": userMaster.userId },
            { "userName": userMaster.userName },
            { "userGroup": userMaster.userGroup },
            { "passwordProfile": userMaster.passwordProfile },
            { "password": userMaster.password },
            { "retypePassword": userMaster.retypePassword },
            { "employeeId": userMaster.employeeId },
            { "designation": userMaster.designation },
            { "startMenu": userMaster.startMenu },
            { "officePhone": userMaster.officePhone },
            { "extension": userMaster.extension },
            { "resPhone": userMaster.resPhone },
            { "mobileNo": userMaster.mobileNo },
            { "fax": userMaster.fax },
            { "email": userMaster.email },
            { "managerId": userMaster.managerId },
            { "defaultCompany": userMaster.defaultCompany },
            { "defaultDivision": userMaster.defaultDivision },
            { "defaultDepartment": userMaster.defaultDepartment },
            { "macAddress": userMaster.macAddress },
            { "userType": userMaster.userType },
            { "partyCode": userMaster.partyCode },
            { "defaultPrinterCode": userMaster.defaultPrinterCode },
            { "shiftCode": userMaster.shiftCode },
            { "multiMachineLoginYN": userMaster.multiMachineLoginYN },
            { "forcedPasswordYN": userMaster.forcedPasswordYN },
            { "passwordExpiryYN": userMaster.passwordExpiryYN },
            { "expiryDate": userMaster.expiryDate },
            { "lockYN": userMaster.lockYN },
            { "userActiveYN": userMaster.userActiveYN },
            { "signatureFile": userMaster.signatureFile },
            { "premiumAccount": userMaster.premiumAccount },
            { "commissionAccount": userMaster.commissionAccount },
            { "deactivationDate": userMaster.deactivationDate }

        ];
        //console.table(valuesToMap);
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setValue(key, i[key])));
        //  }

    }, [userMaster]);


    const onResetUserSearch = () => {
        navigate('');
        resetUserSearch();
        dispatch(actions.clearUserSearchParams());
    }

    const onResetUserMaster = () => {
        navigate('');
        resetUserMaster();
        dispatch(actions.clearUserMasterInformation());
    }


    const onAddNewUser = async () => {
        onResetUserMaster();
        dispatch(actions.showCurrentUserMaster(true));
        dispatch(actions.showUserMaster(true));
        dispatch(actions.collapseUserSearchResults(true));
        dispatch(actions.collapseUserSearch(true));
        scrollToBottom();
    }

    const onError = (errorsUserSearch, e) => console.log(errorsUserSearch, e);

    const updateSortString = async (val) => {
        await dispatch(actions.getUserSortResults(val));
    }

    const onCollapseUserSearch = () => {
        if (userMaster.searchClass === "collapse show") {
            dispatch(actions.collapseUserSearch(true));
        } else {
            dispatch(actions.collapseUserSearch(false));
        }
    }
    const onCollapseUserSearchResult = () => {
        if (userMaster.searchClass === "collapse show") {
            dispatch(actions.collapseUserSearchResults(true));
        } else {
            dispatch(actions.collapseUserSearchResults(false));
        }
    }

    const onUserSubmit = async (data, e) => {
        navigate('');
        await dispatch(actions.getUserSearchResults(1, "userSearch"));
    }


    const handleUserSearch = (e) => {
        let { name, value } = e.target;
        dispatch(actions.updateUserSearchParams({ name, value }));
    }
    const handleUserSearchCheckBoxParams = (e) => {
        let { name, checked } = e.target;
        dispatch(actions.updateUserSearchCheckboxParams({ name, checked }));
    }
    const onErrorsUserMaster = (errorsUserMaster, e) => { console.log(errorsUserMaster, e) }

    const onchangeVal = (options, values) => {
        let name = values.name;
        let value = options;
        dispatch(actions.updateUserMasterParams({ name, value }));
    }
    const onhandleUserMasterSubmit = async (data, e) => {
        let currentUserId = await dispatch(actions.saveUserMasterInfo());
        navigate('?userId=' + currentUserId);
    }
    const onCopyUser = async (data, e) => {
        await dispatch(actions.copyUser());
    }

    const handleUserMaster = (e) => {
        let { name, value } = e.target;
        if (name == 'mobileNo') {
            var checkMobileNo = e.target.value.match(/^[0][5]/)
            if (e.target.value.length === 3 && !userMaster.mobileNo.match(/.*-$/) && checkMobileNo != null) {
                value = value += "-"
            }
            if (checkMobileNo != null) {
                value = value.substr(0, 11);
            }
        }

        if (name == "officePhone") {
            if (e.target.value.length === 2 && !userMaster.officePhone.match(/.*-$/)) {
                value = value += "-"
            }
            value = value.substr(0, 10);
        }
        if (name == "fax") {
            if (e.target.value.length === 2 && !userMaster.fax.match(/.*-$/)) {
                value = value += "-"
            }
            value = value.substr(0, 10);
        }
        if (name == "resPhone") {
            if (e.target.value.length === 2 && !userMaster.resPhone.match(/.*-$/)) {
                value = value += "-"
            }
            value = value.substr(0, 10);
        }
        /* if (name == "userType") {
            if (e.target.value == constants.USER_TYPE_AGENT) {
                dispatch(actions.getPartyCodeByUserType(1));
            }
            else if(e.target.value == constants.USER_TYPE_BROKER){
                dispatch(actions.getPartyCodeByUserType(3));
            }
            else{
                dispatch(actions.clearPartyCodeMaster());
            }
            value = value.substr(0, 10);
        } */
        if (value == "") { value = null }
        dispatch(actions.updateUserMasterParams({ name, value }));
    }
    const handleUserMasterCheckboxParams = (e) => {
        let { name, checked } = e.target;
        dispatch(actions.updateUserMasterCheckboxParams({ name, checked }));

    }
    const onDisplayUser = async (userName, userId) => {

        resetUserMaster();
        dispatch(actions.updateCurrentUserId(userId));
        dispatch(actions.showCurrentUserMaster(true));
        dispatch(actions.showUserMaster(true));
        await dispatch(actions.getUserMaster(userId));
        dispatch(actions.collapseUserSearchResults(true));
        dispatch(actions.collapseUserSearch(true));
        {
            let name = "showApplicableBranchesModal";
            let value = false;
            dispatch(actions.updateModalsStateParams({ name, value }));
        }
        {
            let name = "showPartyCodeModal";
            let value = false;
            dispatch(actions.updateModalsStateParams({ name, value }));
        }
        scrollToBottom();
    }
    const onChangeActiveStatus = async (userId, isActive) => {
        await dispatch(actions.updateUserActiveStatus(userId, isActive));
    }
    const onResetPassword = async (userId, email,userName) => {
        await dispatch(actions.sendForgotPassword(email,userName));
    }
    const onUnlockUser = async (userId) => {
        await dispatch(actions.unlockUser(userId));
    }


    const scrollToBottom = () => {
        refUserMaster.current?.scrollIntoView({ behavior: 'smooth' });
    };
    const onFileChange = (e) => {
        let value = e.docIdEncrypted;
        let name = "signatureFile";
        dispatch(actions.updateUserMasterParams({ name, value }));
        value = e.fileName;
        name = "signatureFileName";
        dispatch(actions.updateUserMasterParams({ name, value }));
    }
    const showApplicableBranches = async () => {
        {
            let name = "showApplicableBranchesModal";
            let value = true;
            dispatch(actions.updateModalsStateParams({ name, value }));
        }
        {
            let name = "showPartyCodeModal";
            let value = false;
            dispatch(actions.updateModalsStateParams({ name, value }));
        }
        await dispatch(actions.getUserApplicableBranches());
    }
    const showPartyCode = async () => {
        {
            let name = "showPartyCodeModal";
            let value = true;
            dispatch(actions.updateModalsStateParams({ name, value }));
        }
        {
            let name = "showApplicableBranchesModal";
            let value = false;
            dispatch(actions.updateModalsStateParams({ name, value }));
        }
        refPartyCode.current?.scrollIntoView({ behavior: 'smooth' });
        //await dispatch(actions.getUserApplicableBranches());
    }

    const onPageChangeRequest = async (page) => {
        await dispatch(actions.getUserSearchResults(page, "userSearch"))
    }

    function renderSearchCriteria() {

        /* let UserID = <input className={errorsUserSearch.userId ? 'form-control is-invalid' : 'form-control fw-bold'}
            id="userId" required=""
            placeholder="--User ID--"
            name='userId'
            {...registerUserSearch("userId", { onChange: (value) => handleUserSearch(value) })}
            value={userSearch.userId}
        /> */

        let UserName = <input className="form-control fw-bold"
            placeholder="--User Name--"
            id="userName"
            name="userName"
            {...registerUserSearch("userName", { onChange: (value) => handleUserSearch(value) })}
            value={userSearch.userName}
        />

        let ActiveFrom = <input className={errorsUserSearch.activeFrom ? 'form-control is-invalid' : 'form-control fw-bold'}
            type="date" id="activeFrom" required=""
            placeholder="DD/MM/YYYY"
            name='activeFrom'
            {...registerUserSearch("activeFrom", { onChange: (value) => handleUserSearch(value) })}
            value={userSearch.activeFrom}
        />
        let ActiveTo = <input className={errorsUserSearch.activeTo ? 'form-control is-invalid' : 'form-control fw-bold'}
            type="date" id="activeTo" required=""
            placeholder="DD/MM/YYYY"
            name='activeTo'
            {...registerUserSearch("activeTo", { min: { value: userSearch.activeFrom, message: "This Date should be greater than or equal to Active From Date" }, onChange: (value) => handleUserSearch(value) })}
            value={userSearch.activeTo}
        />
        let IsActiveYN = <div className="form-check form-check-inline ms-1">
            <label htmlFor="isActiveYN" className="form-label"> Active Users </label>
            <input className="form-check-input"
                type="checkbox"
                id="isActiveYN"
                name="isActiveYN"
                checked={userSearch.isActiveYN}
                {...registerUserSearch("isActiveYN", { onChange: (e) => handleUserSearchCheckBoxParams(e) })}
            />
        </div>
        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <form className={userSearch.searchClass} id="CollapseSearchComponents"
                    onSubmit={onSubmitData(onUserSubmit, onError)} noValidate="noValidate">
                    <div className="row g-2">
                        <div className="mb-1 col-md-12">
                            <div className="btn-group float-end" id="tooltip-container2">
                                <div class="btn-group" role="group" aria-label="Second group">
                                    {checkPermissions.hasResetUserSearch &&
                                        <button type="button" className="btn btn-danger"
                                            data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Reset" onClick={() => onResetUserSearch()}> Reset <i className="mdi mdi-rotate-left"></i></button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-2">
                        {/* <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> User ID </label>
                            {UserID}
                        </div> */}
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> User Name </label>
                            {UserName}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Active From </label>
                            {ActiveFrom}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputPassword4" className="form-label"> Active To </label>
                            {ActiveTo}
                            {errorsUserSearch.activeTo?.message && <span>{errorsUserSearch.activeTo?.message}</span>}
                        </div>
                        <div className="pt-4 col-md-3">
                            {IsActiveYN}
                        </div>

                    </div>

                    <div id="tooltip-container2">
                        {checkPermissions.hasUserSearch && <button type="submit" className="btn btn-primary float-end"
                            data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="Search" ><i className="dripicons-search"></i> Search</button>
                        }
                    </div>

                </form>

            </>

        )
    }

    function renderUserListing() {
        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <div className={userSearch.searchResultClass} id="CollapseSearchResult">
                    <div className="row g-2">
                        <div className="mb-1 col-md-6">
                            {!userSearch.showSearchResult && <h5 className="alert alert-danger">No Records Found...</h5>}
                        </div>
                    </div>
                    {userSearch.showSearchResult &&
                        <>
                            <div className="table-responsive table-sm">
                                <table id="scroll-horizontal-datatable" className=" table table-hover table w-100 nowrap resizeable_table_head">
                                    <thead>

                                        <tr>
                                            <th>Actions</th>
                                            <th onClick={() => updateSortString('UserID')}>User ID ⬇️ </th>
                                            <th onClick={() => updateSortString('UserName')}>User Name ⬇️</th>
                                            <th onClick={() => updateSortString('Designation')}>User Designation ⬇️</th>
                                            {/* <th onClick={() => updateSortString('UserGroup')}>User Group ⬇️</th> */}
                                            <th onClick={() => updateSortString('MobileNo')}>User Mobile ⬇️</th>
                                            <th onClick={() => updateSortString('Email')}>User Email ⬇️</th>
                                            <th onClick={() => updateSortString('IsActive')}> User Active⬇️</th>

                                        </tr>
                                    </thead>
                                    <tbody>

                                        {userSearch.searchResult.result.map((searchResult, index) => (

                                            <tr key={searchResult.userId} className={!searchResult.isActive ? " text-danger" : ''}>
                                                <td>
                                                    <div className="btn-group">
                                                        {checkPermissions.hasViewUser && <button type="button" className="btn btn-info btn-sm" data-bs-container="#tooltip-container2"
                                                            data-bs-toggle="tooltip" data-bs-placement="bottom" title="View" onClick={() => onDisplayUser(searchResult.userName, searchResult.userId)}>
                                                            <i className="dripicons-preview"></i>
                                                        </button>
                                                        }
                                                        {checkPermissions.hasActiveDeactiveUser && <button type="button" className={searchResult.isActive ? "btn btn- btn-secondary btn-sm" : "btn btn- btn-success btn-sm"} data-bs-container="#tooltip-container2"
                                                            data-bs-toggle="tooltip" data-bs-placement="bottom" title={searchResult.isActive ? "Deactivate User" : "Activate User"} onClick={() => onChangeActiveStatus(searchResult.userId, searchResult.isActive)}>
                                                            <i className={searchResult.isActive ? "mdi mdi-account-remove" : "mdi mdi-account-reactivate"}></i>
                                                        </button>
                                                        }
                                                        {checkPermissions.hasUnlockUser && searchResult.isUserBlocked &&
                                                            <button type="button" className="btn btn-warning btn-sm" data-bs-container="#tooltip-container2"
                                                                data-bs-toggle="tooltip" data-bs-placement="bottom" title="Unlock User" onClick={() => onUnlockUser(searchResult.userId)}>
                                                                <i className="uil-unlock"></i>
                                                            </button>
                                                        }
                                                        {checkPermissions.hasResetUserPassword && <button type="button" className="btn btn-primary btn-sm" data-bs-container="#tooltip-container2"
                                                            data-bs-toggle="tooltip" data-bs-placement="bottom" title="Reset Password" onClick={() => onResetPassword(searchResult.userId, searchResult.email, searchResult.userName)}>
                                                            <i className="mdi mdi-rotate-left"></i>
                                                        </button>
                                                        }
                                                    </div>
                                                </td>

                                                <td> {searchResult.userId} </td>
                                                <td> {searchResult.userName} </td>
                                                <td> {searchResult.designation} </td>
                                                {/* <td> {searchResult.userGroup} </td> */}
                                                <td> {searchResult.mobileNo} </td>
                                                <td> {searchResult.email} </td>
                                                <td> <input className="form-check-input"
                                                    type="checkbox"
                                                    checked={searchResult.isActive}
                                                /> </td>

                                            </tr>

                                        ))}

                                    </tbody>
                                </table>
                            </div>
                            <div className="float-end">
                                <CustomPager onPageChangeRequest={onPageChangeRequest} pagedResult={userSearch.searchResult} />
                            </div>
                        </>
                    }
                </div>



            </>
        )
    }

    function renderUserMaster() {

        let UserID = <input className={errorsUserMaster.userId ? 'form-control is-invalid' : 'form-control fw-bold'}
            id="userId" required=""
            placeholder="--User ID--"
            disabled
            name='userId'
            {...registerUserMaster("userId", { onChange: (e) => handleUserMaster(e) })}
            value={userMaster.userId}
        />

        let UserName = <input className={errorsUserMaster.userName ? 'form-control is-invalid' : 'form-control fw-bold'}
            placeholder="--User Name--"
            id="userName"
            name="userName"
            {...registerUserMaster("userName", {
                required: "Field is Required",
                onChange: (e) => handleUserMaster(e)
            })}
            value={userMaster.userName}
        />

        let Password = <input className='form-control fw-bold'
            id="password" required=""
            placeholder="--Password--"
            name='password'
            {...registerUserMaster("password", { onChange: (e) => handleUserMaster(e) })}
            value={userMaster.password}
        />

        let RetypePassword = <input className="form-control fw-bold"
            placeholder="--Retype Password--"
            id="retypePassword"
            name="retypePassword"
            {...registerUserMaster("retypePassword", { onChange: (e) => handleUserMaster(e) })}
            value={userMaster.retypePassword}
        />

        let EmployeeID = <input className={errorsUserMaster.employeeId ? 'form-control is-invalid' : 'form-control fw-bold'}
            id="employeeId" required=""
            placeholder="--Employee ID--"
            name='employeeId'
            {...registerUserMaster("employeeId", {
                pattern: { value: /^[1-9]\d*$/, message: "Format: Numberical Digits Only" },
                onChange: (e) => handleUserMaster(e)
            })}
            value={userMaster.employeeId} //from assure tech if possible
        />

        let Designation = <input className="form-control fw-bold"
            placeholder="--Designation--"
            id="designation"
            name="designation"
            {...registerUserMaster("designation", { onChange: (e) => handleUserMaster(e) })}
            value={userMaster.designation} //from assure tech if possible
        />

        let OfficePhone = <input className={errorsUserMaster.officePhone ? 'form-control is-invalid' : 'form-control fw-bold'}
            type="text" id="officePhone"
            placeholder="--Office Phone--"
            name='officePhone'
            {...registerUserMaster("officePhone", {
                pattern: { value: /^[0][2,3,4,6,7,9]{1}[-]?[0-9]{7}$/, message: "Format: 0X-XXXXXXX" }, onChange: (e) => handleUserMaster(e)
            })}
            value={userMaster.officePhone}
        />

        let Extension = <input className={errorsUserMaster.extension ? 'form-control is-invalid' : 'form-control fw-bold'}
            type="text" id="extension"
            placeholder="--Extension--"
            name='extension'
            {...registerUserMaster("extension", { onChange: (e) => handleUserMaster(e) })}
            value={userMaster.extension}
        />

        let ResPhone = <input className={errorsUserMaster.resPhone ? 'form-control is-invalid' : 'form-control fw-bold'}
            type="text" id="resPhone"
            placeholder="--Res Phone--"
            name='resPhone'
            {...registerUserMaster("resPhone", {
                pattern: { value: /^[0][2,3,4,6,7,9]{1}[-]?[0-9]{7}$/, message: "Format: 0X-XXXXXXX" }, onChange: (e) => handleUserMaster(e)
            })}
            value={userMaster.resPhone}
        />

        let MobileNo = <input className={errorsUserMaster.mobileNo ? 'form-control is-invalid' : 'form-control fw-bold'}
            type="text" id="mobileNo"
            placeholder="--Mobile No--"
            name='mobileNo'
            {...registerUserMaster("mobileNo", { pattern: { value: /(^[0][5][0,5,2,6,4,8]{1}[-]?[0-9]{7}$)|(^[0][2,3,4,6,7,9]{1}[-]?[0-9]{7}$)/, message: "Format: 05X-XXXXXXX / 0X-XXXXXXX" }, onChange: (e) => handleUserMaster(e) })}
            value={userMaster.mobileNo}
        />

        let Fax = <input className={errorsUserMaster.fax ? 'form-control is-invalid' : 'form-control fw-bold'}
            id="fax" required=""
            placeholder="--Fax--"
            name='fax'
            {...registerUserMaster("fax", {
                pattern: { value: /^[0][2,3,4,6,7,9]{1}[-]?[0-9]{7}$/, message: "Format: 0X-XXXXXXX" },
                onChange: (e) => handleUserMaster(e)
            })}
            value={userMaster.fax}
        />

        let Email = <input className={errorsUserMaster.email ? 'form-control is-invalid' : 'form-control fw-bold'}
            placeholder="--Email--"
            id="email"
            name="email"
            {...registerUserMaster("email", {
                required: "Field is Required",
                pattern: { value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, message: "Format: abc@example.com" },
                onChange: (e) => handleUserMaster(e)
            })}
            value={userMaster.email}
        />
        let DefaultCompany = <select className="form-select fw-bold" data-toggle="select2" id="defaultCompany" name="defaultCompany"
            {...registerUserMaster("defaultCompany", { onChange: (e) => handleUserMaster(e) })}
            value={userMaster.defaultCompany}
        >
            <option value="">--User Company--</option>
            {masters.companyMasters.map((companyMasters, index) => (
                <option value={companyMasters.domainValue} key={companyMasters.domainValue}>
                    {companyMasters.domainValueName}
                </option>
            ))}
        </select>

        let DefaultPrinterCode = <input className={errorsUserMaster.defaultPrinterCode ? 'form-control is-invalid' : 'form-control fw-bold'}
            placeholder="--Default Printer Code--"
            id="defaultPrinterCode"
            name="defaultPrinterCode"
            {...registerUserMaster("defaultPrinterCode", {
                pattern: { value: /^[0-9]\d*$/, message: "Format: Numberical Digits Only" },
                onChange: (e) => handleUserMaster(e)

            })}
            value={userMaster.defaultPrinterCode}
        />//DROPDOWN

        let MacAddress = <input className="form-control fw-bold"
            placeholder="--MAC Address--"
            id="macAddress"
            name="macAddress"
            {...registerUserMaster("macAddress", { onChange: (e) => handleUserMaster(e) })}
            value={userMaster.macAddress}
        />

        let PartyCode = <select className="form-select fw-bold" data-toggle="select2" id="partyCode" name="partyCode"
            {...registerUserMaster("partyCode", { onChange: (e) => handleUserMaster(e) })}
            value={userMaster.partyCode}
        >
            <option value="">--Party Code--</option>
            {masters.partyCodeMasters.filter(p => (p.partyAccountType == 1 && userMaster.userType == constants.USER_TYPE_AGENT) ||
                (p.partyAccountType == 3 && userMaster.userType == constants.USER_TYPE_BROKER)).map((partyCodeMasters, index) => (
                    <option value={partyCodeMasters.partyCode} key={partyCodeMasters.accId}>
                        {partyCodeMasters.partyCode + " - " + partyCodeMasters.partyName}
                    </option>
                ))}
        </select>


        let SelectSignatureFile = <select className="form-select fw-bold" type="file" id="selectSignatureFile" name="selectSignatureFile"
            {...registerUserMaster("selectSignatureFile", { onChange: (e) => handleUserMaster(e) })}
            value={userMaster.selectSignatureFile}
        >
            <option value="">--Choose File--</option>
        </select>

        let UserGroup = <Select
            options={masters.userGroupMasters}
            className="basic-multi-select fw-bold" data-toggle="select2" id="userGroup" name="userGroup" isMulti
            placeholder="--Select User Group--"
            register={registerUserMaster}
            onChange={onchangeVal}
            value={userMaster.userGroup}
            getOptionLabel={option => option.groupName}
            getOptionValue={option => option.groupId}
        //labelValues={["groupId", "groupName"]}
        >
        </Select>


        let PasswordProfile = <select className="form-select fw-bold" data-toggle="select2" id="passwordProfile" name="passwordProfile"
            {...registerUserMaster("passwordProfile", { required: true, onChange: (e) => handleUserMaster(e) })}
            value={userMaster.passwordProfile}
        >
            <option value="">--Password Profile--</option>
            {masters.passwordProfileMasters.map((passwordProfileMasters, index) => (
                <option value={passwordProfileMasters.domainValue} key={passwordProfileMasters.domainValue}>
                    {passwordProfileMasters.domainValueName}
                </option>
            ))}
        </select>

        let StartMenu = <select className="form-select fw-bold" data-toggle="select2" id="startMenu" name="startMenu"
            {...registerUserMaster("startMenu", { onChange: (e) => handleUserMaster(e) })}
            value={userMaster.startMenu}
        >
            <option value="">--Start Menu--</option>
        </select>

        let ManagerId = <select className="form-select fw-bold" data-toggle="select2" id="managerId" name="managerId"
            {...registerUserMaster("managerId", { onChange: (e) => handleUserMaster(e) })}
            value={userMaster.managerId}
        >
            <option value="">--Manager Id--</option>

        </select> //from assure tech if possible

        let DefaultDivision = <select className="form-select fw-bold" data-toggle="select2" id="defaultDivision" name="defaultDivision"
            {...registerUserMaster("defaultDivision", { onChange: (e) => handleUserMaster(e) })}
            value={userMaster.defaultDivision}
        >
            <option value="">--Default Division--</option>
            {masters.branchMasters.map((branchMasters, index) => (
                <option value={branchMasters.brCode} key={branchMasters.brCode}>
                    {branchMasters.brName}
                </option>
            ))}
        </select>

        let DefaultDepartment = <select className="form-select fw-bold" data-toggle="select2" id="defaultDepartment" name="defaultDepartment"
            {...registerUserMaster("defaultDepartment", { onChange: (e) => handleUserMaster(e) })}
            value={userMaster.defaultDepartment}
        >
            <option value="">--Default Department--</option>
            {masters.departmentMasters.map((departmentMasters, index) => (
                <option value={departmentMasters.domainValue} key={departmentMasters.domainValue}>
                    {departmentMasters.domainValueName}
                </option>
            ))}
        </select>

        let UserType = <select className="form-select fw-bold" data-toggle="select2" id="userType" name="userType"
            {...registerUserMaster("userType", { onChange: (e) => handleUserMaster(e) })}
            value={userMaster.userType}
        >
            <option value="">--User Type--</option>
            {masters.userTypesMasters.map((userTypesMasters, index) => (
                <option value={userTypesMasters.domainValue} key={userTypesMasters.domainValue}>
                    {userTypesMasters.domainValueName}
                </option>
            ))}
        </select>

        let ShiftCode = <select className="form-select fw-bold" data-toggle="select2" id="shiftCode" name="shiftCode"
            {...registerUserMaster("shiftCode", { onChange: (e) => handleUserMaster(e) })}
            value={userMaster.shiftCode}
        >
            <option value="">--Shift Code--</option>
        </select>

        let MultiMachineLogin = <div className="form-check" id="Check1">
            <input type="checkbox" id="multiMachineLoginYN" className="form-check-input" name="multiMachineLoginYN"
                onChange={(e) => handleUserMasterCheckboxParams(e)}
                checked={userMaster.multiMachineLoginYN}
                value={userMaster.multiMachineLoginYN} />
        </div>
        let ForcedPassword = <div className="form-check" id="Check1">
            <input type="checkbox" id="forcedPasswordYN" className="form-check-input" name="forcedPasswordYN"
                onChange={(e) => handleUserMasterCheckboxParams(e)}
                checked={userMaster.forcedPasswordYN}
                value={userMaster.forcedPasswordYN} />
        </div>
        let PasswordExpiry = <div className="form-check" id="Check1">
            <input type="checkbox" id="passwordExpiryYN" className="form-check-input" name="passwordExpiryYN"
                onChange={(e) => handleUserMasterCheckboxParams(e)}
                checked={userMaster.passwordExpiryYN}
                value={userMaster.passwordExpiryYN} />
        </div>
        let Lock = <div className="form-check" id="Check1">
            <input type="checkbox" id="lockYN" className="form-check-input" name="lockYN"
                {...registerUserMaster("lockYN", { onChange: (e) => handleUserMasterCheckboxParams(e) })}
                checked={userMaster.lockYN}
                value={userMaster.lockYN} />
        </div>
        let UserActive = <div className="form-check" id="Check1">
            <input type="checkbox" id="userActiveYN" className="form-check-input" name="userActiveYN"
                {...registerUserMaster("userActiveYN", { onChange: (e) => handleUserMasterCheckboxParams(e) })}
                checked={userMaster.userActiveYN}
                value={userMaster.userActiveYN} />

        </div>

        let ExpiryDate = <input className={errorsUserMaster.expiryDate ? 'form-control is-invalid' : 'form-control fw-bold'}
            type="date" id="expiryDate" required=""
            placeholder="DD/MM/YYYY"
            name='expiryDate'
            {...registerUserMaster("expiryDate", { onChange: (e) => handleUserMaster(e) })}
            value={userMaster.expiryDate}
        />
        let DeactivationDate = <input className={errorsUserMaster.deactivationDate ? 'form-control is-invalid' : 'form-control fw-bold'}
            type="date" id="deactivationDate" 
            disabled={true}
            placeholder="DD/MM/YYYY"
            name='deactivationDate'
            {...registerUserMaster("deactivationDate", { required: false, onChange: (e) => handleUserMaster(e) })}
            value={userMaster.deactivationDate}
        />





        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <form className="collapse show" id="CollapseUserMaster"
                    onSubmit={onSubmitUserMaster(onhandleUserMasterSubmit, onErrorsUserMaster)} noValidate="noValidate">

                    <div className="row g-2">
                        <div className="mb-1 col-md-12">
                            <div className="btn-group float-end" id="tooltip-container2">
                                <div class="btn-group" role="group" aria-label="Second group">
                                    {checkPermissions.hasResetUser && <button type="button" className="btn btn-danger"
                                        data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Reset" onClick={() => onResetUserMaster()}> Reset <i className="mdi mdi-rotate-left"></i></button>

                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> User ID </label>
                            {UserID}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> User Name </label>
                            {UserName}
                            {errorsUserMaster.userName?.message && <span>{errorsUserMaster.userName?.message}</span>}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> User Group </label>
                            {UserGroup}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Password Profile </label>
                            {PasswordProfile}
                        </div>
                    </div>

                    <div className="row g-2">
                        {/* <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Password </label>
                            {Password}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Retype Password </label>
                            {RetypePassword}
                        </div> */}
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Employee ID </label>
                            {EmployeeID}
                            {errorsUserMaster.employeeId?.message && <span>{errorsUserMaster.employeeId?.message}</span>}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Designation </label>
                            {Designation}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Office Phone </label>
                            {OfficePhone}
                            {errorsUserMaster.officePhone?.message && <span>{errorsUserMaster.officePhone?.message}</span>}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Extension </label>
                            {Extension}
                        </div>
                    </div>

                    <div className="row g-2">
                        {/* <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Start Menu </label>
                            {StartMenu}
                        </div> */}
                        {/* <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Office Phone </label>
                            {OfficePhone}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Extension </label>
                            {Extension}
                        </div> */}
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> ResPhone </label>
                            {ResPhone}
                            {errorsUserMaster.resPhone?.message && <span>{errorsUserMaster.resPhone?.message}</span>}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Mobile No </label>
                            {MobileNo}
                            {errorsUserMaster.mobileNo?.message && <span>{errorsUserMaster.mobileNo?.message}</span>}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Fax </label>
                            {Fax}
                            {errorsUserMaster.fax?.message && <span>{errorsUserMaster.fax?.message}</span>}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Email </label>
                            {Email}
                            {errorsUserMaster.email?.message && <span>{errorsUserMaster.email?.message}</span>}
                        </div>
                    </div>

                    <div className="row g-2">
                        {/* <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Mobile No </label>
                            {MobileNo}
                            {errorsUserMaster.mobileNo?.message && <span>{errorsUserMaster.mobileNo?.message}</span>}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Fax </label>
                            {Fax}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Email </label>
                            {Email}
                            {errorsUserMaster.email?.message && <span>{errorsUserMaster.email?.message}</span>}
                        </div> */}
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Manager ID </label>
                            {ManagerId}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Default Company </label>
                            {DefaultCompany}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Default Division </label>
                            {DefaultDivision}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Default Department </label>
                            {DefaultDepartment}
                        </div>
                    </div>

                    <div className="row g-2">
                        {/* <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Default Company </label>
                            {DefaultCompany}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Default Division </label>
                            {DefaultDivision}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Default Department </label>
                            {DefaultDepartment}
                        </div> */}
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> MAC Address </label>
                            {MacAddress}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> User Type </label>
                            {UserType}
                        </div>
                        {/* <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Party Code </label>
                            {PartyCode}
                        </div> */}
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Default Printer Code </label>
                            {DefaultPrinterCode}
                            {errorsUserMaster.defaultPrinterCode?.message && <span>{errorsUserMaster.defaultPrinterCode?.message}</span>}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Expiry Date </label>
                            {ExpiryDate}
                        </div>
                    </div> 
                    <div className="row g-2">
                        
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Deactivaton Date </label>
                            {DeactivationDate}
                        </div>
                    </div>

                    {/* <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> User Type </label>
                            {UserType}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Party Code </label>
                            {PartyCode}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Default Printer Code </label>
                            {DefaultPrinterCode}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Shift Code </label>
                            {ShiftCode}
                        </div>
                    </div> */}

                    <div className="row g-2">
                        <div className="mb-3 col-md-3 d-inline-flex">
                            {MultiMachineLogin}
                            <label class="form-label" for="multiMachineLoginYN" >Multi Machine Login Y/N</label>
                        </div>

                        <div className="mb-3 col-md-3 d-inline-flex">
                            {Lock}
                            <label class="form-label" for="lockYN"> Lock Y/N</label>
                        </div>

                        <div className="mb-3 col-md-3 d-inline-flex">
                            {UserActive}
                            <label class="form-label" for="userActiveYN">User Active Y/N</label>
                        </div>
                        {/* <div className="mb-3 col-md-3 d-inline-flex">
                            {ForcedPassword}
                            <label class="form-label" for="forcedPasswordYN">Forced Password Y/N</label>
                        </div>

                        <div className="mb-3 col-md-3 d-inline-flex">
                            {PasswordExpiry}
                            <label class="form-label" for="passwordExpiryYN">Password Expiry Y/N</label>
                        </div> */}

                    </div>

                    <div className="row g-2">
                        <div className="mb-3 col-md-3">

                            <label class="form-label" >Select Signature File </label><div>
                                <CustomFileUpload className={errorsUserMaster.signatureFile ? 'form-control is-invalid' : 'form-control'}
                                    id="signatureFile"
                                    name="signatureFile"
                                    {...registerUserMaster("signatureFile", { required: false/*true && (memberInformation.photoId == null || memberInformation.photoId === "")*/ })}
                                    onChange={e => onFileChange(e)}
                                    value={userMaster.signatureFile}
                                    file={userMaster.signatureFileName}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row g-2">
                        <div className="mb-3 col-md-6">
                            <div id="tooltip-container2" /* className='btn-group' */>
                                {checkPermissions.hasUserApplicableBranch && userMaster.userId != null &&
                                    <button type="button" className="btn btn-primary float-start me-1"
                                        data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="ApplicationBranch" onClick={() => showApplicableBranches()}> Applicable Branch</button>
                                }
                                {checkPermissions.hasUserPartyCode &&
                                    <button type="button" className="btn btn-primary float-start"
                                        data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="PartyCode" onClick={() => showPartyCode()}> Party Code</button>
                                }
                            </div>
                        </div>
                        <div className="mb-3 col-md-6">
                            <div id="tooltip-container2">
                                {checkPermissions.hasSaveUser && <button type="submit" className="btn btn-success float-end"
                                    data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Save" ><i className="mdi mdi-content-save"></i> Save   </button>
                                }
                            </div>
                            {checkPermissions.hasCopyUser && userMaster.userId != null &&
                                <div id="tooltip-container2">
                                    <button type="button" className="btn btn-success float-end me-1" aria-pressed="true"
                                        data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Copy" onClick={() => onCopyUser()}><i className="dripicons-copy"></i> Copy    </button>
                                </div>

                            }
                        </div>
                        {/* <div className="mb-3 col-md-3">
                            <div id="tooltip-container2">
                                <button type="button" className="btn btn-danger float-end"
                                    data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cancel" > Cancel   </button>
                            </div>
                        </div> */}
                    </div>
                </form>
            </>
        )
    }


    function renderPartyCode() {


        let PremiumAccount = <input className={errorsUserMaster.premiumAccount ? 'form-control fw-bold is-invalid' : 'form-control fw-bold'}
            id="premiumAccount"
            placeholder="--Premium Acc--"
            name='premiumAccount'
            //required= {userMaster.userType == constants.USER_TYPE_AGENT || userMaster.userType == constants.USER_TYPE_BROKER}

            //onChange={(e) => handleUserMaster(e)}
            {...registerUserMaster("premiumAccount", { required: userMaster.userType == constants.USER_TYPE_AGENT || userMaster.userType == constants.USER_TYPE_BROKER, onChange: (e) => handleUserMaster(e) })}
            value={userMaster.premiumAccount}
        />
        let CommissionAccount = <input className={errorsUserMaster.commissionAccount ? 'form-control fw-bold is-invalid' : 'form-control fw-bold'}
            id="commissionAccount"
            placeholder="--Commission Acc--"
            name='commissionAccount'
            //required= {userMaster.userType == constants.USER_TYPE_AGENT || userMaster.userType == constants.USER_TYPE_BROKER}
            //onChange={(e) => handleUserMaster(e)}
            {...registerUserMaster("commissionAccount", { required: userMaster.userType == constants.USER_TYPE_AGENT || userMaster.userType == constants.USER_TYPE_BROKER, onChange: (e) => handleUserMaster(e) })}
            value={userMaster.commissionAccount}
        />
        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>

                <div className="row g-2">

                    <div className="mb-3 col-md-3"></div>

                    <div className="mb-3 col-md-3">
                        <label htmlFor="inputState" className="form-label">{(userMaster.userType == constants.USER_TYPE_AGENT || userMaster.userType == constants.USER_TYPE_BROKER) && <span className='redstar'>*</span>} Premium Account </label>
                        {PremiumAccount}
                    </div>
                    <div className="mb-3 col-md-3">
                        <label htmlFor="inputState" className="form-label">{(userMaster.userType == constants.USER_TYPE_AGENT || userMaster.userType == constants.USER_TYPE_BROKER) && <span className='redstar'>*</span>} Commission Account </label>
                        {CommissionAccount}
                    </div>

                    <div className="mb-3 col-md-3"></div>
                </div>



            </>
        )
    }


    return (

        <>

            <div className="wrapper">
                <LeftSideMenu />
                <div class="content-page">
                    <TopBar />
                    <div class="content">
                        <DashboardTitle />
                        <div className="content">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card ribbon-box">
                                        <div className="card-body">
                                            <div className="ribbon ribbon-primary float-start"><i className="mdi mdi-clipboard-text-search-outline me-1 mb-0"></i>User</div>
                                            <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i>Search Criteria</div>
                                            <div className="float-end" /* className="btn-group float-end" */ id="tooltip-container2">
                                                {checkPermissions.hasAddNewUser &&
                                                    <button type="button" className="btn btn-md btn-success" data-bs-container="#tooltip-container2"
                                                        data-bs-toggle="tooltip" data-bs-placement="bottom" title="Add New User" onClick={() => onAddNewUser()}>
                                                        <i className="dripicons-plus"></i> New User
                                                    </button>
                                                }
                                                <button className="btn btn-md btn-light ms-1" type="button" id="searchcollapsableButton"
                                                    data-bs-toggle="collapse" data-bs-target="#CollapseSearchComponents"
                                                    aria-expanded="false" aria-controls="CollapseSearchComponents" onClick={() => onCollapseUserSearch()} >
                                                    <i className="mdi mdi-arrow-up-down"></i>
                                                </button>
                                            </div>
                                            <h5 className="text-primary float-end mt-0"> </h5>
                                            <div className="ribbon-content">
                                                {renderSearchCriteria()}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {userSearch.isSubmit &&
                            <div className="content">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card ribbon-box">
                                            <div className="card-body">
                                                <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i>User Listing</div>
                                                <div className="btn-group float-end" id="tooltip-container2">
                                                    <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchresultscollapsableButton"
                                                        data-bs-toggle="collapse" data-bs-target="#CollapseSearchResult"
                                                        aria-expanded="false" aria-controls="CollapseSearchResult" onClick={() => onCollapseUserSearchResult()}>
                                                        <i className="mdi mdi-arrow-up-down"></i>
                                                    </button>
                                                </div>
                                                <h5 className="text-primary float-end mt-0"> </h5>
                                                <div className="ribbon-content">
                                                    {renderUserListing()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }


                        {userMaster.showUserMaster &&
                            <div className="row" ref={refUserMaster}>
                                <div className="content">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="card ribbon-box">
                                                <div className="card-body">
                                                    <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i>User Master</div>
                                                    <div className="btn-group float-end" id="tooltip-container2">
                                                        <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchcollapsableButton"
                                                            data-bs-toggle="collapse" data-bs-target="#CollapseUserMaster"
                                                            aria-expanded="false" aria-controls="CollapseUserMaster" /*onClick={() => onCollapseSearch()}*/>
                                                            <i className="mdi mdi-arrow-up-down"></i>
                                                        </button>
                                                    </div>
                                                    <h5 className="text-primary float-end mt-0"> </h5>
                                                    <div className="ribbon-content">
                                                        {renderUserMaster()}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {modalsState.showPartyCodeModal &&
                            <div className="row" ref={refPartyCode}>
                                <div className="content">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="card ribbon-box">
                                                <div className="card-body">
                                                    <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i>Party Code</div>
                                                    <div className="btn-group float-end" id="tooltip-container2">
                                                        <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchcollapsableButton"
                                                            data-bs-toggle="collapse" data-bs-target="#CollapsePartyCode"
                                                            aria-expanded="false" aria-controls="CollapsePartyCode" /*onClick={() => onCollapseSearch()}*/>
                                                            <i className="mdi mdi-arrow-up-down"></i>
                                                        </button>
                                                    </div>
                                                    <h5 className="text-primary float-end mt-0"> </h5>
                                                    <div className="ribbon-content">
                                                        {renderPartyCode()}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }


                        {modalsState.showApplicableBranchesModal &&
                            <ApplicableBrancehes />
                        }
                    </div>
                    <Footer />
                </div>

            </div>

        </>
    )
}